import { render, staticRenderFns } from "./GameResultTournamentDetailsModal.vue?vue&type=template&id=247050dd&"
import script from "./GameResultTournamentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./GameResultTournamentDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports